import { ReactNode } from 'react';
import { Modal as _Modal, ModalProps } from 'antd';

export default function Modal(props: ModalProps & { children?: ReactNode }) {
    return <_Modal {...props}>{props.children || ''}</_Modal>;
}
